import { Box, Button, ChakraProvider, Flex, Text } from '@chakra-ui/react'
import Moment from 'moment'
import React, { Component } from 'react'
import { PERMISSION_USER } from '../../../lib/controleuseraux'
import '../../../sass/app.scss'
import {
  AtualizaCubagemPorCaixa,
  AtualizaStatusPedido,
  AtualizaUsuarioDevolucao,
  AtualizaUsuarioEmiteNota,
  ListaCubagemPorCaixa,
  ListaImpressoes,
  ListaInfoPNota,
  ListaStatusPedido,
  ListaTelasCRM,
  ListaVendedoresAtivos,
  runVerificaAutenticacao,
  baseURL,
} from '../../../services/api'
import { ContentModalFinalizar } from './components/ContentModalFinalizar'

import * as S from './styles'

import { ModalCubagem } from './components/ModalCubagem'
import FiltroStatusPedido from './FiltroStatusPedido'
import { ModalTrocas } from './Trocas/ModalTrocas'
import { Tr } from './Tr'
import { InitialModalFilter } from './components/InitialModalFilter'
import { user } from '../../../helpers/user'

const loading = '/images/loading.gif'

const CODPERMISSIONS = [
  0, 22, 21, 30, 19, 50, 82, 121, 51, 45, 48, 52, 53, 54, 55, 56, 23, 14, 12, 60, 66, 72, 75, 90, 91, 76, 77, 83, 87, 85, 103, 110, 116, 114, 115, 126, 127, 128,
]

const delay = async (ms = 1000) => new Promise((resolve) => setTimeout(resolve, ms))

class StatusPedido extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dados: [],
      sequencia: null,
      dados_cubagem: [],
      dados_info_p_nota: [],
      loading: false,
      loadingFinalizacao: false,
      view_modal_cubagem: false,
      view_modal_finalizacao: false,
      view_modal_trocas: false,
      filtro_impressoes: [{ value: 0, label: 0 }],
      vendedores: [{ value: null, label: null }],
      codigo_usuario: JSON.parse(localStorage.getItem('authentication')).codigo_usuario,
      control_inclusao: null,
      control_alteracao: null,
      control_exclusao: null,
      control_consulta: null,
      drawerOpen: false,
      initialModal: false,
    }
  }

  componentDidMount() {
    runVerificaAutenticacao()
    this.initial()
  }

  initial = async () => {
    await this.CarregaPermissoes()

    // this.ListaStatusPedido()
    this.ListaFiltros()
    this.getVendedores()
    this.OpenInitialModal()
  }

  OpenInitialModal = () => {
    this.setState({ initialModal: true })
  }

  CarregaPermissoes = async () => {
    try {
      const response = await ListaTelasCRM.get('/' + window.location.pathname.replace('/', ''))
      const data = response.data

      let codigo_tela = null
      for (const obj in data) {
        codigo_tela = obj
      }

      this.setState({
        codigo_tela,
        control_inclusao: JSON.parse(localStorage.getItem('authentication')).permissoes_usuario[codigo_tela].inclusao,
        control_alteracao: JSON.parse(localStorage.getItem('authentication')).permissoes_usuario[codigo_tela].alteracao,
        control_exclusao: JSON.parse(localStorage.getItem('authentication')).permissoes_usuario[codigo_tela].exclusao,
        control_consulta: JSON.parse(localStorage.getItem('authentication')).permissoes_usuario[codigo_tela].consulta,
        codigo_usuario: JSON.parse(localStorage.getItem('authentication')).codigo_usuario,
      })
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  getVendedores = async () => {
    try {
      const response = await ListaVendedoresAtivos.get()
      const data = response.data

      const vendedores = []
      vendedores.push({ value: null, label: null })
      data.map((data) => {
        vendedores.push({
          value: data.codigo_usuario,
          label: data.nome_vendedor,
        })
      })

      this.setState({ vendedores })
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  ListaStatusPedido = async () => {
    if (this.state.control_consulta != 'S') {
      alert('Permissão negada')
      return false
    }
    const user =
      this.state.vendedor_selecionado != undefined
        ? this.state.vendedor_selecionado
        : CODPERMISSIONS.includes(this.state.codigo_usuario)
          ? null
          : this.state.codigo_usuario

    console.log('user', user)

    try {
      this.setState({ loading: true })
      const response = await ListaStatusPedido.post('', {
        codigo_usuario: user,
      })
      const data = response.data
      this.setState({ dados: data, loading: false })
    } catch (error) {
      this.setState({ loading: false })
      console.log(Object.keys(error), error.message)
    }
  }

  ListaFiltros = async () => {
    try {
      const response = await ListaImpressoes.get()
      const data = response.data

      this.setState({ filtro_impressoes: data })
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  enviarEmiteNota = async (e, usuario) => {
    if (usuario.includes('SUP', 'AMANDA')) {
      e.target.checked = false
      return alert('Não é possível emitir a nota, por favor atualize a cubagem.')
    }

    if (window.confirm('Você esta prestes a confirmar a emissão de nota fiscal')) {
      const data = JSON.parse(e.target.value)
      const numero_nota = data.data.codigo_nota
      const codigo_produto = data.data.codigo_produto
      const sequencia = data.data.sequencia
      const param = {
        numero_nota,
        sequencia,
        cod_prod: codigo_produto,
        codigo_usuario: this.state.codigo_usuario,
      }
      try {
        const response = await AtualizaUsuarioEmiteNota.post('', param)
        const data = response.data
        this.FiltrarStatus()
      } catch (error) {
        console.log(Object.keys(error), error.message)
      }
    } else {
      e.target.checked = false
    }
  }

  saveInputStep = async (e, field, id = null, validacao = null, verifique = false) => {
    if (this.state.control_alteracao != 'S') {
      alert('Permissão negada')
      return false
    }

    const { codigo_fornecedor } = JSON.parse(e.target.value)

    if (field === 'data_compre_ganhe') {
      if (!window.confirm('Você esta prestes a confirmar o Compre e Ganhe. Deseja continuar?')) {
        e.target.checked = false
        return false
      }
      console.log('target', e.target.value)

      const params = {
        usuario: this.state.codigo_usuario,
        coluna: 'COMPREGANHE',
      }
      const response = await AtualizaStatusPedido.post('', params)

      console.log(params)
    }

    if (field === 'data_saiu_entrega') {
      try {
        const params = {
          coluna: JSON.parse(e.target.value).coluna,
          usuario: this.state.codigo_usuario,
          codigo_produto: JSON.parse(e.target.value).codigo_produto,
          sequencia: JSON.parse(e.target.value).sequencia,
          numero_nota: JSON.parse(e.target.value).numero_nota,
        }

        const response = await AtualizaStatusPedido.post('', params)

        console.log('response', response)

        e.target.checked = true
      } catch (error) {
        console.log(Object.keys(error), error.message)
        e.target.checked = false
      }

      return
    }

    const dataPassoAnterior = new Date(validacao.data_passo_anterior)
    const tempoNecessario = 10
    const currentTime = new Date()

    const notForn10Minutes = ['120', '129']

    if (
      field !== 'data_aprova_piloto' &&
      field !== 'data_atualizacao_cubagem' &&
      field !== 'data_inicio_personalizacao' &&
      field !== 'data_compre_ganhe' &&
      field !== 'data_prevista_controle_qualidade' &&
      field !== 'data_recebimento' &&
      !notForn10Minutes.includes(codigo_fornecedor) &&
      user.codigo_usuario !== 72 &&
      (currentTime - dataPassoAnterior) / 1000 / 60 < tempoNecessario
    ) {
      alert('é necessário aguardar 10 minutos para concluir esta etapa.')
      e.target.checked = false
      return false
    }

    if (
      field === 'data_controle_qualidade' &&
      ![21, 72, 48, 30, 45, 58, 45, 0, 21, 82, 121, 48, 83, 87, 85, 72, 116, 121, 126, 127, 128].includes(this.state.codigo_usuario)
    ) {
      alert('Você não tem permissão para alterar este campo.')
      e.target.checked = false
      return false
    }

    if (field === 'data_aprova_piloto' && 
      ![21, 72, 30, 19, 60, 45, 0, 21, 83, 87, 85, 72, 121, 126, 127, 128].includes(this.state.codigo_usuario)
    ) {
      alert('Você não tem permissão para alterar este campo.')
      e.target.checked = false
      return false
    }

    if (
      field === 'data_desembalagem' &&
      ![21, 72, 30, 45, 50, 82, 121, 45, 0, 21, 82, 121, 48, 83, 87, 85, 72, 110, 116, 121, 126, 127, 128].includes(this.state.codigo_usuario)
    ) {
      alert('Você não tem permissão para alterar este campo.')
      e.target.checked = false
      return false
    }

    if (field === 'data_recebimento' && ![19, 30, 72, 83, 87, 121, 126, 127, 128].includes(this.state.codigo_usuario)) {
      alert('Você não tem permissão para alterar este campo.')
      e.target.checked = false
      return false
    }

    if (
      field === 'data_prevista_controle_qualidade' &&
      ![21, 72, 30, 45, 50, 82, 45, 0, 21, 48, 82, 121, 83, 87, 85, 72, 110, 116, 121, 126, 127, 128].includes(this.state.codigo_usuario)
    ) {
      alert('Você não tem permissão para alterar este campo.')
      e.target.checked = false
      return false
    }

    if (field === 'data_pedido_entregue') {
      const despache = window.confirm('Despachar em lote?')

      const params = {
        coluna: JSON.parse(e.target.value).coluna,
        usuario: this.state.codigo_usuario,
        codigo_produto: JSON.parse(e.target.value).codigo_produto,
        sequencia: JSON.parse(e.target.value).sequencia,
        numero_nota: JSON.parse(e.target.value).numero_nota,
        numero_pedido: JSON.parse(e.target.value).numero_pedido,
        despache: false,
      }

      if (despache) {
        const newParams = {
          ...params,
          despache: true,
        }

        const response = await AtualizaStatusPedido.post('', newParams)

        console.log('response', response)

        e.target.checked = true
        this.FiltrarStatus()
        return
      }

      const response = await AtualizaStatusPedido.post('', params)

      console.log('response', response)

      e.target.checked = true
      this.FiltrarStatus()
      return
    }

    if (field == 'data_despacho' && [0, 30, 22, 60, 66, 72, 45, 0, 21, 83, 87, 85, 72, 121, 126, 127, 128].includes(this.state.codigo_usuario)) {
      var dados = Object.entries(JSON.parse(e.target.value))
      let data_prev = prompt('Qual será a nova data de despacho?\r\n(Formato: DD/MM/YYYY. Exemplo: 01/01/2021)')
      data_prev = data_prev.split('/')[2] + data_prev.split('/')[1] + data_prev.split('/')[0]

      if (data_prev != '' && data_prev != null && data_prev != undefined) {
        dados.push(['data_prev_despacho', Moment(data_prev).format('YYYY-MM-DD')])

        if (new Date(Moment(data_prev).format('YYYY-MM-DD')) != 'Invalid Date') {
          var data = Object.fromEntries(dados)

          try {
            let qtd_item = 0
            this.state.dados.map(async (item) => {
              if (item.numero_pedido == data.numero_pedido) {
                qtd_item++
              }
            })

            let count = 0
            this.state.dados.map(async (item) => {
              if (item.numero_pedido == data.numero_pedido) {
                count++
                const param = {
                  usuario: this.state.codigo_usuario,
                  numero_nota: item.codigo_nota,
                  numero_pedido: data.numero_pedido,
                  codigo_produto: item.codigo_produto,
                  sequencia: item.sequencia,
                  data_prev_despacho: Moment(data_prev).format('YYYY-MM-DD'),
                }

                const response = await AtualizaStatusPedido.post('', param)
                console.log('RESPONSE: ', response)
                await delay(1200)
                const obj = response.data
              }
            })

            await delay(1200)
            e.target.checked = false
            this.FiltrarStatus()
          } catch (error) {
            alert('Erro ao atualizar data. Contate o suporte.')
            console.log(Object.keys(error), error.message)
          }
        } else {
          alert('Formato de data inválido')
        }

        return true
      } else {
        return false
      }
    }

    try {
      var dados = JSON.parse(e.target.value)

      if (
        validacao.data_passo_anterior == '' &&
        field !== 'data_prevista_despacho' &&
        field != 'data_saida_compra' &&
        // field != "data_recebimento" &&
        field != 'data_bloqueio' &&
        field != 'data_libera_bloqueio'
      ) {
        alert('É necessario completar o passo anterior para concluir esta etapa.')
        e.target.checked = false
      } else {
        const permissions = PERMISSION_USER

        if (field === 'data_prevista_controle_qualidade') {
          // Solicita o número de pessoas trabalhando na embalagem
          const numPessoas = window.prompt('Quantas pessoas estão trabalhando na desembalagem?')

          const numPessoasInt = parseInt(numPessoas)

          const nomes = []

          for (let i = 0; i < numPessoasInt; i++) {
            const nome = window.prompt('Insira o nome da pessoa ' + (i + 1) + ':')
            nomes.push(nome)
          }

          if (numPessoas == null) {
            e.target.checked = false
            return
          }

          if (!numPessoas || !numPessoasInt || numPessoasInt < 1) {
            alert('É necessário inserir o número de pessoas')
            e.target.checked = false
            return
          }
          // se o nome for vazio, não atualiza
          if (nomes[0] == '') {
            alert('É necessário inserir o nome das pessoas')
            e.target.checked = false
            return
          }

          console.log('Os nomes das pessoas são: ' + nomes.join(', '))

          const params = {
            ...dados,
            nomes,
          }

          console.log('PARAMS: ', params)

          if (nomes.length > 0) {
            const response = await AtualizaStatusPedido.post('', params)

            console.log('RESPONSE: ', response)

            this.FiltrarStatus()
          } else {
            alert('É necessário inserir o nome das pessoas')
            e.target.checked = false
            return
          }

          return
        }

        if (permissions[this.state.codigo_usuario].PERMISSION.includes(id)) {
          if (field == 'data_controle_qualidade') {
            if (
              validacao.data_atualizacao_cubagem != '' &&
              validacao.data_atualizacao_cubagem != undefined &&
              validacao.data_atualizacao_cubagem != null
            ) {
              if (verifique) {
                const response = await AtualizaStatusPedido.post('', dados)
                console.log('RESPONSE: ', response)
                var data = response.data

                if (data.atualizado) {
                  this.FiltrarStatus()
                  // this.setState({ lastInputSavedTime: currentTime });
                } else {
                  e.target.checked = false
                  alert('Pedido não atualizado.')
                }
              } else if (window.confirm('Você esta prestes a concluir um passo da produção do pedido, deseja continuar?')) {
                const response = await AtualizaStatusPedido.post('', dados)
                console.log('RESPONSE: ', response)
                var data = response.data

                if (data.atualizado) {
                  this.FiltrarStatus()
                } else {
                  e.target.checked = false
                  alert('Pedido não atualizado.')
                }
              } else {
                e.target.checked = false
              }
            } else {
              e.target.checked = false
              alert('É necessário atualizar a cubagem antes de iniciar a personalização.')
            }
          } else {
            if (validacao.desbloqueio) {
              if (verifique) {
                const response = await AtualizaStatusPedido.post('', dados)
                var data = response.data
                console.log('RESPONSE: ', response)

                if (data.atualizado) {
                  e.target.checked = false
                  this.FiltrarStatus()
                  // this.setState({ lastInputSavedTime: currentTime });
                } else {
                  e.target.checked = false
                  alert('Pedido não atualizado.')
                }
              } else if (window.confirm('Você esta prestes a concluir um passo da produção do pedido, deseja continuar?')) {
                const response = await AtualizaStatusPedido.post('', dados)
                var data = response.data

                console.log('RESPONSE: ', response)

                if (data.atualizado) {
                  e.target.checked = false
                  this.FiltrarStatus()
                  // this.setState({ lastInputSavedTime: currentTime });
                } else {
                  e.target.checked = false
                  alert('Pedido não atualizado.')
                }
              } else {
                e.target.checked = false
              }
            } else {
              e.target.checked = false
              alert('Este pedido esta bloqueado. Entre em contato com o Administrador.')
            }
          }
        } else {
          e.target.checked = false
          alert('Acesso negado. Entre em contato com o suporte.')
        }
      }
    } catch (error) {
      e.target.checked = false
      alert('Acesso negado. Entre em contato com o suporte.')
      console.log(Object.keys(error), error.message)
    }
  }

  changeInputField = async (elem, type, field) => {
    if (type === 'select') {
      this.setState({ [field]: elem.value })
    } else if (type == 'input') {
      this.setState({ [field]: elem.target.value })
    }
  }

  FiltrarStatus = async () => {
    if (this.state.control_consulta != 'S') {
      alert('Permissão negada')
      return false
    }
    const user = CODPERMISSIONS.includes(this.state.codigo_usuario) ? null : this.state.codigo_usuario

    try {
      this.setState({ loading: true })

      const param = {
        codigo_usuario: user,
        numero_pedido: this.state.pedido_selecionado,
        id_gravacao: this.state.impressao_selecionado,
        prazo_producao: this.state.prazo_selecionado,
        status_pedido: this.state.status_selecionado,
        data_de_despacho: this.state.data_de_selecionada,
        data_ate_despacho: this.state.data_ate_selecionada,
        tipo_filtro_entrega: this.state.entrega_selecionada,
        tipo_transportadora: this.state.tipo_transportadora,
        data_relatorio: this.state.data_relatorio,
      }

      const response = await ListaStatusPedido.post('', param)

      const data = response.data.map((item) => {
        if (item.valida_cupom !== '') {
          item.brinde_pedido = `${item.brinde_pedido} + ${item.valida_cupom}`
        }

        return item
      })

      this.setState({ dados: data, loading: false })
      this.setState({
        drawerOpen: false,
      })
    } catch (error) {
      this.setState({ loading: false })
      console.log(Object.keys(error), error.message)
    }
  }

  ModalAtualizaCubagem = async (e) => {
    var data = JSON.parse(e.target.value)

    if ([45, 72, 19, 0, 30, 83, 87, 121, 126, 127, 128].includes(this.state.codigo_usuario)) {
      try {
        // this.setState({ loading: true });
        const response = await ListaCubagemPorCaixa.get('/' + data.codigo_produto)
        var data = response.data

        this.setState({ dados_cubagem: data, view_modal_cubagem: true })

        let cont = 1
        data.map((data) => {
          document.getElementById('quantidade-caixa-' + cont).value = data.qtd_por_caixa
          cont++
        })
        this.setState({ loading: false })
      } catch (error) {
        this.setState({ loading: false })
        console.log(Object.keys(error), error.message)
      }
    } else {
      alert('Acesso negado. Entre em contato com o suporte.')
    }
  }

  ModalFinalizacao = async (e) => {
    var data = JSON.parse(e.target.value)
    const numero_nota = data.data.codigo_nota
    const codigo_produto = data.data.codigo_produto
    const sequencia = data.data.sequencia

    if ([0, 30, 19, 22, 45, 48, 60, 66, 45, 0, 21, 72, 83, 87, 85, 82, 121, 116, 126, 127, 128].includes(this.state.codigo_usuario)) {
      try {
        this.setState({ loadingFinalizacao: true })
        const response = await ListaInfoPNota.get('/' + codigo_produto + '/' + numero_nota + '/' + sequencia)
        var data = response.data
        this.setState({
          dados_info_p_nota: data,
          view_modal_finalizacao: true,
        })

        this.setState({ loadingFinalizacao: false })
      } catch (error) {
        this.setState({ loadingFinalizacao: false })
        console.log(Object.keys(error), error.message)
      }
    } else {
      alert('Acesso negado. Entre em contato com o suporte.')
    }
  }

  ModalTrocas = async (e) => {
    var data = JSON.parse(e.target.value)
    const numero_nota = data.data.codigo_nota
    const codigo_produto = data.data.codigo_produto
    const sequencia = data.data.sequencia

    try {
      this.setState({ loadingFinalizacao: true })
      const response = await ListaInfoPNota.get('/' + codigo_produto + '/' + numero_nota + '/' + sequencia)
      var data = response.data
      this.setState({
        dados_solicitacao_troca: data,
        view_modal_trocas: true,
        cod_prod: codigo_produto,
        numero_nota,
        sequencia,
      })

      const params = data.map((item) => {
        return {
          cod_prod: item.cod_prod,
          numero_nota: item.numero_nota,
          sequencia: item.sequencia,
        }
      })

      const send = await baseURL.get(
        '/pedido/listar-informacoes-troca' + '/' + params[0].cod_prod + '/' + params[0].numero_nota + '/' + params[0].sequencia
      )

      this.setState({
        dados_solicitacao_troca: send.data,
      })

      this.setState({ loadingFinalizacao: false })
    } catch (error) {
      this.setState({ loadingFinalizacao: false })
      console.log(Object.keys(error), error.message)
    }
  }

  changeQuantidadeCubagem = async (e) => {
    const value = e.target.value
    const idcaixa = JSON.parse(e.target.attributes.data.value).id_caixa

    this.state.dados_cubagem.map((data) => {
      if (data.id_caixa == idcaixa) {
        data.qtd_por_caixa = value
      }
    })
  }

  DespacharEmLote = async () => {
    try {
      const pedidos = prompt('Digite a baixo quais pedidos deseja despachar. \r\n(Exemplo: 1234, 4567, 8910)')

      if (pedidos != '') {
        const codigos = pedidos.split(',')

        codigos.map((numero_pedido) => {
          this.state.dados.map((data) => {
            if (data.numero_pedido == numero_pedido) {
              const param = {
                coluna: 'DTENTREGUE',
                usuario: this.state.codigo_usuario,
                numero_nota: data.codigo_nota,
                numero_pedido: data.numero_pedido,
                codigo_produto: data.codigo_produto,
                sequencia: data.sequencia,
              }

              this.saveInputStep(
                { target: { value: JSON.stringify(param) } },
                'data_pedido_entregue',
                8,
                {
                  data_passo_anterior: data.data_controle_qualidade,
                  data_passo_atual: data.data_pedido_entregue,
                },
                true
              )
            }
          })
        })
      }
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  salvarAlteracoes = async () => {
    const cubagens = this.state.dados_cubagem.map((item) => item.qtd_por_caixa)

    // se todos estiverem vazios, não faz nada
    if (cubagens.every((item) => item === '' || item === '0')) {
      alert('Pelo menos uma caixa deve ter uma quantidade de cubagem diferente de 0.')
      return
    }

    try {
      this.setState({ loading: true })
      this.state.dados_cubagem.map(async (data) => {
        const param = {
          quantidade_caixa: parseInt(data.qtd_por_caixa),
          codigo_usuario: this.state.codigo_usuario,
          codigo_produto: parseInt(data.codigo_produto),
          id_caixa: parseInt(data.id_caixa),
        }
        const response = await AtualizaCubagemPorCaixa.post('', param)
        const rst = response.data

        if (!rst.result) {
          alert('Algo deu errado na atualização da cubagem. contate o suporte.')
        }
      })
      this.setState({ loading: false, view_modal_cubagem: false })
      this.ListaStatusPedido()
      // this.ModalAtualizaCubagem();
    } catch (error) {
      this.setState({ loading: false })
      console.log(Object.keys(error), error.message)
    }
  }

  VisualizarObservacao = (e) => {
    const obs = e.target.attributes.data.value
  }

  getAtualizaUsuarioDevolucao = async (e) => {
    if (window.confirm('Você esta prestes a confirmar a troca dos produtos!')) {
      try {
        const data = JSON.parse(e.target.value)
        const numero_nota = data.data.codigo_nota
        const cod_prod = data.data.codigo_produto
        const sequencia = data.data.sequencia
        const cod_usu = this.state.codigo_usuario

        const response = await AtualizaUsuarioDevolucao.get('/' + cod_usu + '/' + numero_nota + '/' + cod_prod + '/' + sequencia)
        const dados = response

        console.log('dados', dados)

        this.FiltrarStatus()
      } catch (error) {
        console.log(Object.keys(error), error.message)
      }
    } else {
      e.target.checked = false
    }
  }

  EditarObservacao = async (e) => {
    const item = JSON.parse(e.target.attributes.data.value)
    const obs = prompt('Digite uma observação para este pedido:')

    if (obs != null && obs != '') {
      const param = {
        usuario: this.state.codigo_usuario,
        numero_nota: item.codigo_nota,
        numero_pedido: item.numero_pedido,
        codigo_produto: item.codigo_produto,
        sequencia: item.sequencia,
        observacao: obs,
      }

      const response = await AtualizaStatusPedido.post('', param)
      await delay(1000)
      alert('Observação salva com sucesso.')
      this.FiltrarStatus()
    } else {
      alert('A observação não pode ser vázia.')
    }
  }

  render() {
    const counterNumPed = this.state.dados.filter(
      (item, index, self) => self.findIndex((t) => t.numero_pedido === item.numero_pedido) === index
    ).length

    const { dados, filtro_impressoes, vendedores } = this.state

    const optionsGravacao = [{ value: '', label: '' }]
    filtro_impressoes.map(function (data) {
      optionsGravacao.push({
        value: data.codigo_impressao,
        label: data.descricao_impressao,
      })
    })
    const optionsEntregue = [
      { id: '0', text: '' },
      { id: '1', text: 'ENTREGUE' },
      { id: '2', text: 'NÃO ENTREGUE' },
      { id: '3', text: 'TODOS' },
    ].map(function (data) {
      return { value: data.id, label: data.text }
    })

    const optionsPrazo = [
      { id: '1', text: '1 DIA' },
      { id: '3', text: '3 DIAS' },
      { id: '5', text: '5 DIAS' },
      { id: '7', text: '7 DIAS' },
      { id: '10', text: '10 DIAS' },
    ].map(function (data) {
      return { value: data.id, label: data.text }
    })

    const optionsTransp = [
      { id: '', text: '' },
      { id: '1', text: 'CLIENTE RETIRA' },
      { id: '2', text: 'NOSSO CARRO' },
      { id: '4', text: 'Motoboy' },
      { id: '3', text: 'OUTROS' },
    ].map(function (data) {
      return { value: data.id, label: data.text }
    })

    const optionsStatus = [
      { id: '', text: '' },
      { id: 'DT_LIBER_ORD_PROD', text: 'Ordem De Produção' },
      { id: 'DT_SAIDA_COMPRA', text: 'Saida Para Compra' },
      { id: 'DT_RECEBIMENTO', text: 'Recebimento' },
      { id: 'DT_PRE_CTLE_QUAL', text: 'Inicio Desembalagem' },
      { id: 'DT_DESEMBALAGEM', text: 'Finalização Desembalagem' },
      { id: 'DT_INI_PERSON', text: 'Inicio/Personalização' },
      { id: 'DT_FIN_PERSON', text: 'Término/Personalização' },
      { id: 'DT_CTLE_QUAL', text: 'Finalização' },
      { id: 'DT_PED_DESPACHADO', text: 'Pedido Despacho Em' },
    ].map(function (data) {
      return { value: data.id, label: data.text }
    })

    function validaBloqueioPedido(bloqueio, desbloqueio) {
      if (bloqueio != '' && bloqueio != null && (desbloqueio == '' || desbloqueio == null)) {
        return false
      }

      if (desbloqueio != '' || desbloqueio != null) {
        return true
      }
    }

    return (
      <ChakraProvider>
        <InitialModalFilter
          isOpen={this.state.initialModal}
          onClose={() => this.setState({ initialModal: false })}
          FiltrarStatus={this.FiltrarStatus}
          changeInputField={this.changeInputField}
          state={this.state.dados}
        />
        <S.StatusPedidoContainer
          filter={this.state.view_modal_finalizacao ? 'auto' : 'none'}
          blur={this.state.view_modal_finalizacao ? '2px' : 'none'}
        >
          <S.StatusPedidoContainerText>
            <h1>
              <strong>STATUS </strong>PEDIDOS
            </h1>
          </S.StatusPedidoContainerText>

          {this.state.view_modal_cubagem ? (
            <>
              <ModalCubagem
                cubagem={this.state.dados_cubagem}
                salvar={() => this.salvarAlteracoes()}
                fechar={() => this.setState({ view_modal_cubagem: false })}
                isOpen={this.state.view_modal_cubagem}
                onChange={(e) => this.changeQuantidadeCubagem(e)}
              />
            </>
          ) : (
            <></>
          )}

          {this.state.view_modal_finalizacao && (
            <S.PedidoContainerModalFinalizar>
              <S.PedidoContainerModalContentFinalizar>
                <ContentModalFinalizar
                  usuario={this.state.codigo_usuario}
                  FiltrarStatus={this.FiltrarStatus}
                  closeButton={() => this.setState({ view_modal_finalizacao: false })}
                  dados_info_p_nota={this.state.dados_info_p_nota}
                  loading={this.loading}
                />
              </S.PedidoContainerModalContentFinalizar>
            </S.PedidoContainerModalFinalizar>
          )}

          {this.state.view_modal_trocas && (
            <ModalTrocas
              usuario={this.state.codigo_usuario}
              filtrarStatus={this.FiltrarStatus}
              dados={this.state.dados_solicitacao_troca}
              numeroNota={this.state.numero_nota}
              codProduto={this.state.cod_prod}
              sequencia={this.state.sequencia}
              onClose={() => this.setState({ view_modal_trocas: false })}
            />
          )}
          <Flex w="100%" alignItems="center" justifyContent="center" mt="1rem">
            <FiltroStatusPedido
              onClick={() =>
                this.setState({
                  drawerOpen: !this.state.drawerOpen,
                })
              }
              open={this.state.drawerOpen}
              onClose={() =>
                this.setState({
                  drawerOpen: !this.state.drawerOpen,
                })
              }
              isDisabled={this.state.loading}
              changeInputField={this.changeInputField}
              FiltrarStatus={this.FiltrarStatus}
              DespacharEmLote={this.DespacharEmLote}
              codigo_usuario={this.state.codigo_usuario}
              optionsTransp={optionsTransp}
              optionsStatus={optionsStatus}
              optionsEntregue={optionsEntregue}
              optionsPrazo={optionsPrazo}
              optionsGravacao={this.state.filtro_impressoes}
              optionsVendedor={this.state.vendedores}
            />
          </Flex>

          <Text fontSize="1.2rem" fontWeight="bold" color="#606163" marginLeft={'2rem'}>
            {counterNumPed} Pedidos
          </Text>

          <S.ResumeContentTables
            filter={this.state.view_modal_finalizacao ? 'auto' : 'none'}
            blur={this.state.view_modal_finalizacao ? '2px' : 'none'}
          >
            <S.ResumeContentTablesColumn>
              <S.ResumeContentTablesColumnTitle>
                <Box display={'flex'} alignItems="center" justifyContent="center">
                  <strong>Acompanhamento dos pedidos </strong>
                  <Box ml={20}>
                    <Button
                      as="a"
                      href="https://api.innovationbrindes.com.br/api/site/v2/orcamento/visualiza-etiqueta-fragil"
                      target="_blank"
                      colorScheme="blue"
                      size="sm"
                    >
                      Etiqueta frágil
                    </Button>
                  </Box>
                </Box>
              </S.ResumeContentTablesColumnTitle>
              <S.ResumeContentTablesColumnLoading style={this.state.loading ? { display: 'block' } : { display: 'none' }}>
                <S.ResumeContentTablesColumnLoadingContent>
                  <img alt="loading" src={loading} />
                </S.ResumeContentTablesColumnLoadingContent>
              </S.ResumeContentTablesColumnLoading>
              <S.ResumeContentTable>
                <S.ResumeContentTablesOrder>
                  <thead>
                    <th>Pedido</th>
                    <th>Empresa</th>
                    <th>Bloqueio</th>
                    <th>Desbloqueio</th>
                    <th>
                      Nome <br /> Transportadora
                    </th>
                    <th>Nome</th>
                    <th>Código</th>
                    <th>Descrição</th>
                    <th>Cor</th>
                    <th>Personalização</th>
                    <th>Quantidade</th>
                    <th>
                      Prazo de <br /> produção
                    </th>
                    {/* <th>Limite de produção</th> */}
                    <th>
                      Pedido aprovado
                      <br />
                      pelo cliente
                    </th>
                    <th>
                      Enviado
                      <br /> para liberação
                    </th>
                    <th>
                      Aprovação de
                      <br />
                      crédito
                    </th>
                    <th>
                      Pedido
                      <br />
                      confirmado em
                    </th>
                    <th>
                      Confirmação
                      <br />
                      de estoque
                    </th>
                    <th>
                      Liberação ordem de
                      <br />
                      produção
                    </th>
                    <th>Saida para compra</th>
                    <th>Recebimento</th>
                    <th>
                      Inicio <br />
                      Desembalagem
                    </th>
                    <th>
                      Solicitação <br />
                      de trocas
                    </th>
                    <th>Recebimento troca</th>
                    <th>Troca concluída</th>
                    <th>
                      Finalização <br /> Desembalagem
                    </th>
                    <th>
                      Aprovação
                      <br />
                      Piloto
                    </th>
                    <th>
                      Inicio/
                      <br />
                      personalização
                    </th>

                    <th>
                      Término/
                      <br />
                      personalização
                    </th>
                    <th>
                      Atualização
                      <br />
                      Cubagem
                    </th>
                    <th>Info P Nota</th>
                    <th>Finalização</th>
                    <th>
                      Emissão de <br />
                      Nota Fiscal
                    </th>
                    <th>Observação Entrega</th>
                    <th>Desconto Produto</th>
                    <th>
                      Compre e ganhe
                      <br />
                      do pedido
                    </th>
                    <th>Saiu para entrega</th>
                    <th>Entregue</th>
                  </thead>

                  <tbody>
                    {dados.map((data) => {
                      console.log('data, ', data)
                      return (
                        <Tr
                          key={data.numero_nota}
                          data={data}
                          onClick={() => this.handleOpenModal(data.numero_nota)}
                          validaBloqueioPedido={validaBloqueioPedido}
                          saveInputStep={this.saveInputStep}
                          VisualizarObservacao={this.VisualizarObservacao}
                          EditarObservacao={this.EditarObservacao}
                          codUsuario={this.state.codigo_usuario}
                          ModalAtualizaCubagem={this.ModalAtualizaCubagem}
                          ModalTrocas={this.ModalTrocas}
                          getAtualizaUsuarioDevolucao={this.getAtualizaUsuarioDevolucao}
                          ModalFinalizacao={this.ModalFinalizacao}
                          enviarEmiteNota={this.enviarEmiteNota}
                          filtrarStatus={this.FiltrarStatus}
                          dataItem={dados}
                        />
                      )
                    })}
                  </tbody>
                </S.ResumeContentTablesOrder>
              </S.ResumeContentTable>
            </S.ResumeContentTablesColumn>
          </S.ResumeContentTables>
        </S.StatusPedidoContainer>
      </ChakraProvider>
    )
  }
}

export default StatusPedido
